import { InfoOutlined as InfoOutlinedIcon } from "@material-ui/icons";

export const FormUIUtil = {
  renderFormItem,
};

function renderFormItem(label: any, value: any, withoutIcon: boolean = false, withRequired: boolean = false) {
  const icon = withoutIcon ? <InfoOutlinedIcon style={{ marginLeft: "0.5rem" }} /> : "";
  const required = withRequired ? <span style={{color: "red", marginLeft: "0.5rem"}}> *</span>: ""
  return (
    <div className="form-item">
      <div className="form-label">
        {label} {icon} {required}
      </div>
      {value}
    </div>
  );
}
